module.exports = __webpack_public_path__ + "media/images/icon__xco--rb-gray-c1ace1efc420c76e1e098717e0a4c35e.png";